import React from 'react'
import { withStyles, useTheme } from '@material-ui/core/styles'

import { Avatar, IconButton, Menu, MenuItem, ListItemText, makeStyles } from '@material-ui/core'

const StyledMenu = withStyles({})((props) => (
	<Menu
		elevation={0}
		getContentAnchorEl={null}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'right'
		}}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'right'
		}}
		{...props}
	/>
))

const StyledMenuItem = withStyles((theme) => ({
	root: {
		color: 'rgba(255,255,255,0.6)',
		fontFamily: 'Nunito',
		position: 'relative',
		paddingLeft: 24,
		fontWeight: 'bold',
		'&:hover': {
			backgroundColor: 'rgba(107, 74, 214, 0.1)'
		},
		'&.active': {
			opacity: 1,
			backgroundColor: 'rgba(107, 74, 214, 0.1)'
		}
	}
}))(MenuItem)

const useStyles = makeStyles((theme) => ({
	avatarButton: {
		height: 32,
		width: 32,
		padding: 0,
		marginRight: 10,
		'&:hover': {
			backgroundColor: 'transparent'
		}
	},
	avatar: {
		width: 32,
		height: 32,
		backgroundColor: '#6B4AD6',
		color: '#FFFFFF',
		fontSize: 12,
		fontWeight: 'bold',
		fontFamily: 'Nunito'
	}
}))

const UserMenu = (props) => {
	const classes = useStyles()
	const theme = useTheme()

	const [anchorEl, setAnchorEl] = React.useState(null)

	let { user, logOut } = props

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	let first_name
	let last_name

	if (user?.displayName) {
		let split = user.displayName.split(' ')
		if (split.length === 2) {
			first_name = split[0]
			last_name = split[1]
		}
	}

	return (
		<div>
			<IconButton className={classes.avatarButton} onClick={handleClick}>
				<Avatar className={classes.avatar}>
					{first_name && last_name 
						? `${first_name[0]}${last_name[0]}`
						: null}
				</Avatar>
			</IconButton>
			<StyledMenu
				id="customized-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}>
				<StyledMenuItem onClick={logOut}>
					<ListItemText primary="Log out" style={{ color: theme.palette.secondary.main }} />
				</StyledMenuItem>
			</StyledMenu>
		</div>
	)
}

export default UserMenu
